import { Stack } from "@mui/material";
import CopyToClipboard from "react-copy-to-clipboard";

import PrimaryButton from "../../../Components/Buttons/primary-button";

import renderDeletePayee from "./delete-payee";

import { useModalContext } from "../../../Contexts/ModalContext";

import { dispatchSuccessToast } from "../../../Utils/helpers";
import { modalVariants } from "../../../Utils/constants";

import { Copy } from "../../../Assets/Icons";

export default function renderPayeeDetails(modalContext, payee) {
  const { updateModalComponent, pushModalStack, setModalClassName, setModalVariant, setModalTitle } = modalContext;

  updateModalComponent(() => <PayeeDetails payee={payee} />);
  pushModalStack(() => renderPayeeDetails(modalContext, payee));
  setModalVariant(modalVariants.flexDialog);
  setModalTitle("Payee Details");
  setModalClassName("payee-details no-full-screen");
}

const PayeeDetails = ({ payee }) => {
  const modalContext = useModalContext();

  const handleDeletePayee = () => renderDeletePayee(modalContext, payee);

  return (
    <>
      <div className="modal-dialog-content">
        <Stack direction="column" gap="10px">
          <Stack direction="row" alignItems="center" gap="10px">
            <Stack direction="column" padding="4px 0" rowGap="4px" flex="1 0">
              <div className="text-base-regular color--american-silver">Name</div>
              <div className="text-lg-medium color--mist">{payee?.name}</div>
            </Stack>
            <Stack direction="column" padding="4px 0" rowGap="4px" flex="1 0">
              <div className="text-base-regular color--american-silver">Bank</div>
              <div className="text-lg-medium color--mist">{payee?.account?.split(" ")?.[0]}</div>
            </Stack>
          </Stack>
          <Stack direction="row" alignItems="center" gap="10px">
            <Stack direction="column" padding="4px 0" rowGap="4px" flex="1 0">
              <div className="text-base-regular color--american-silver">Routing number</div>
              <Stack direction="row" alignItems="center" gap="8px" className="text-lg-medium color--mist">
                {payee?.routing_number}
                <CopyToClipboard
                  text={payee?.routing_number}
                  onCopy={() => dispatchSuccessToast("Copied to clipboard", { key: "routing_number" })}
                >
                  <div className="copy">
                    <Copy />
                  </div>
                </CopyToClipboard>
              </Stack>
            </Stack>
            <Stack direction="column" padding="4px 0" rowGap="4px" flex="1 0">
              <div className="text-base-regular color--american-silver">Account number</div>
              <Stack direction="row" alignItems="center" gap="8px" className="text-lg-medium color--mist">
                {payee?.account_number}
                <CopyToClipboard
                  text={payee?.account_number}
                  onCopy={() => dispatchSuccessToast("Copied to clipboard", { key: "account_number" })}
                >
                  <div className="copy">
                    <Copy />
                  </div>
                </CopyToClipboard>
              </Stack>
            </Stack>
          </Stack>
        </Stack>
      </div>
      <div className="action-container split-equally">
        <PrimaryButton className="red-theme" onClick={handleDeletePayee}>
          Delete
        </PrimaryButton>
      </div>
    </>
  );
};
